import dayjs from "dayjs";
import { useParams } from "react-router";
import ReactToPrint from "react-to-print";
import React, {
  useContext,
  useRef,
  useCallback,
  useState,
  useEffect,
} from "react";
import { FiPrinter } from "react-icons/fi";
import QRCode from "react-qr-code";
import "./InvoiceUser.css";
import { Link } from "react-router-dom";
import { IoCloudDownloadOutline } from "react-icons/io5";
import {
  TableCell,
  TableHeader,
  Table,
  TableContainer,
  WindmillContext,
} from "@windmill/react-ui";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Cookies from "universal-cookie";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";
// MUI
import Grid from "@mui/material/Grid";
// import Status from '../components/table/Status';
import Status from "../../../admin/components/table/Status";
// import Invoice from '../components/invoice/Invoice';
import Invoice from "../../../admin/components/invoice/Invoice";
// import logoDark from '../assets/img/logo/logo-dark.svg';
// import logoDark from './../../../admin/assets/img/logo/logoDark.svg'
// import logoLight from './../admin/assets/img/logo/logo-light.svg';
// import PageTitle from '../components/Typography/PageTitle';
import PageTitle from "../../../operator/components/Typography/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import { IoArrowBack } from "react-icons/io5";
// API
import { bookingBySearch } from "../../../Redux/userReducer";
import language from "../../../language";
import moment from "moment";
import Header3 from "../../mainLayout/Header/Header3";
import Footer from "../../mainLayout/Footer/Footer";
const InvoiceUser = () => {
  const [bookingData, setBookingData] = useState();
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const dispatch = useDispatch();
  const { mode } = useContext(WindmillContext);
  const { id } = useParams();
  const printRef = useRef();
  const cookies = new Cookies();
  const location = useLocation();
  const mainMessage = location.state?.mainMessage;
  const backHome = location.state?.backHome;
  console.log("Main Message:", mainMessage);

  // Redux
  const searchedData = useSelector((state) => state?.userReducer?.searchDataH2);
  const bookingId = useSelector((state) => state?.userReducer?.bookingId);
  const priceData = useSelector((state) => state?.userReducer?.priceDataH2);
  const bookingInfo = useSelector((state) => state?.bookings?.bookingInfo);
  const requesInfo = useSelector((state) => state?.buses?.requesInfo);
  const departurePrice = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripPrice
  );
  const returnPrice = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripPrice
  );
  const discount = useSelector(
    (state) => state?.bookings?.bookingInfo?.discountPercentage
  );
  const [newPrice, setNewPrice] = useState(departurePrice);
  const [newReturnPrice, setNewReturnPrice] = useState(returnPrice);
  const preCouponSubtotal = useSelector(
    (state) => state?.bookings?.bookingInfo?.subtotal
  );
  const [issueDate1, setIssueDate1] = useState("");
  const [issueDate2, setIssueDate2] = useState("");
  const [trip1DepartureDate, setTrip1DepartureDate] = useState("");
  const [trip1DepartureTime, setTrip1DepartureTime] = useState("");
  const [trip1ReturnDate, setTrip1ReturnDate] = useState("");
  const [trip1ReturnTime, setTrip1ReturnTime] = useState("");
  const [trip2DepartureDate, setTrip2DepartureDate] = useState("");
  const [trip2DepartureTime, setTrip2DepartureTime] = useState("");
  const bookingDetails = useSelector(
    (state) => state?.bookings?.completedBooking
  );

  // const bookingDetails = JSON.parse(sessionStorage.getItem('bookingDetails'))
  let result = bookingId;

  const isLogin = cookies.get("token");

  function formatDate(createdAt) {
    const date = new Date(createdAt);

    // Extract day, month, and year
    const day = date.getUTCDate(); // Day of the month (1-31)
    const month = date.getUTCMonth() + 1; // Months are zero-based (0-11)
    const year = date.getUTCFullYear(); // Year

    // Format as DD/MM/YYYY
    return `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;
  }

  useEffect(() => {
    if (!bookingDetails || bookingDetails.length === 0) return;

    setIssueDate1(formatDate(bookingDetails?.createdAt));
    setIssueDate2(formatDate(bookingDetails?.createdAt));
    setTrip1DepartureDate(formatDate(bookingDetails[0]?.trip?.departureTime));
    setTrip1DepartureTime(
      moment(bookingDetails[0]?.trip?.departureTime).format("h:mm a")
    );
    setTrip1ReturnDate(formatDate(bookingDetails[0]?.trip?.arrivalTime));
    setTrip1ReturnTime(
      moment(bookingDetails[0]?.trip?.arrivalTime).format("h:mm a")
    );
    setTrip2DepartureDate(formatDate(bookingDetails[1]?.trip?.departureTime));
    setTrip2DepartureTime(
      moment(bookingDetails[1]?.trip?.departureTime).format("h:mm a")
    );
  }, [bookingDetails]);

  function calculateTimeDifference(departureTime, arrivalTime) {
    // Parse the times into Date objects
    const departure = new Date(departureTime);
    const arrival = new Date(arrivalTime);

    // Calculate the difference in milliseconds
    const diffMilliseconds = Math.abs(arrival - departure);

    // Convert milliseconds to hours and minutes
    const totalMinutes = Math.floor(diffMilliseconds / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format as "hours:minutes"
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;
  }

  //   const departureTime = bookingDetails[0]?.trip?.routeFrom;
  // const arrivalTime = "2024-01-01T02:34:00.000Z";
  // const timeDifference = calculateTimeDifference(bookingDetails[0]?.trip?.departureTime, bookingDetails[0]?.trip?.arrivalTime);
  // const timeDifference1 = calculateTimeDifference(bookingDetails[1]?.trip?.departureTime, bookingDetails[1]?.trip?.arrivalTime);

  const QRData = {
    // bookingId: bookingId,
    // fareAmount: priceData.fareAmount,
    // noOfSeats: priceData.passengerNumber,
    // departureCity: priceData.departureCity,
    // arrivalCity: priceData.arrivalCity,
    // departureTime: priceData.departure,
    // arrivalTime: priceData.arrival,
    // date: priceData.date,
  };

  // If bookingID is successfully received
  useEffect(() => {
    const getBookingFunction = async () => {
      const response = await dispatch(bookingBySearch(bookingId));
      setBookingData(response.payload);
    };
    getBookingFunction();
  }, []);

  console.log(bookingDetails, "requesInfotripTyp");
  useEffect(() => {
    if (departurePrice && discount) {
      const discountAmount = (departurePrice * discount) / 100; // Calculate the discount amount
      setNewPrice(departurePrice - discountAmount); // Update newPrice
    } else {
      setNewPrice(departurePrice); // If no discount, set to original price
    }
  }, [departurePrice, discount]);
  useEffect(() => {
    // Calculate new return price
    if (returnPrice && discount) {
      const discountAmount = (returnPrice * discount) / 100; // Calculate the discount amount
      setNewReturnPrice(returnPrice - discountAmount); // Update newReturnPrice
    } else {
      setNewReturnPrice(returnPrice); // If no discount, set to original price
    }
  }, [returnPrice, discount]);

  console.log(bookingDetails, "inVoicebookingDetails");

  return (
    <>
      {backHome === 1 && <Header3 />}
      <div className="mainContainerInvoice">
        <div className="mainContainerInvoiceInner">
          {backHome === 1 && (
            <Link to="/" className="Nodecor">
              <div className="backHomeText">
                <IoArrowBack />
                Back to home
              </div>
            </Link>
          )}
          <div className="walletMessageText">{mainMessage?.walletMessage}</div>
          {bookingDetails?.bookingStatus == "cancelled by me" && (
            <div
              className="walletMessageText"
              style={{ textAlign: "center", fontWeight: "700" }}
            >
              This booking has been cancelled{" "}
            </div>
          )}

          <div
            ref={printRef}
            className="  rounded-xl  overflow-hidden invoicPrintable"
          >
            <Grid container className="">
              <Grid item xs={12} display="flex" justifyContent="center">
                <Grid container xs={12} lg={11} className="invoiceInnerSection">
                  <Grid item xs="auto" sm={12}>
                    <p className="travel-itinerary-main text-[20px] text-[#5D0139] font-bold">
                      {languageSelectedEnglish
                        ? "Travel Itinerary"
                        : language.travelItinerary}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs="auto"
                    sm={3}
                    className="p-2 flex justify-between gap-[10px]"
                  >
                    <div className="flex flex-col pb-4 border-b border-gray-50">
                      <h1 className="title-travel-status">
                        {bookingDetails?.type == "Package"
                          ? "Package Travel Itinerary"
                          : "Trip-1 Travel Itinerary"}
                      </h1>
                      <p className="statusSection">
                        {languageSelectedEnglish ? "Status:" : language.status}{" "}
                        <span className="pl-2 confirmText">
                          {" "}
                          <Status status={"Confirmed"} />
                          Confirmed
                        </span>
                      </p>
                      <div className="pt-2 qrOuter">
                        <QRCode
                          value={JSON.stringify(QRData)}
                          level="M"
                          size="100%"
                          fgColor="#5D0139"
                        />
                      </div>

                      <div className="lg:text-right text-left">
                        <p className="travel-deadline">
                          {searchedData?.to}
                          {
                            bookingDetails?.tripDetails[0]?.trip?.routeFrom
                          } to {bookingDetails?.tripDetails[0]?.trip?.routeTo}
                          {searchedData?.from}
                        </p>
                      </div>
                    </div>
                    <div className="divider "></div>
                  </Grid>

                  <Grid item xs="auto" sm={3} className="p-2">
                    <div className="flex flex-col">
                      <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                        <span className="numberText">
                          {languageSelectedEnglish
                            ? "Travel Itinerary"
                            : language.travelItinerary}{" "}
                          Number <br />
                        </span>
                        {/* <span className="alotNo">{bookingDetails[0]?.travelItineraryNumber}</span> */}
                        <span className="alotNo">
                          {bookingDetails?.travelItineraryNumber}
                        </span>
                      </div>
                      <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                        <span className="numberText">
                          {languageSelectedEnglish
                            ? "Itinerary Issue Date"
                            : language.date}
                          <br />
                        </span>
                        <span className="dateText">
                          <span> {issueDate1}</span>
                        </span>
                      </div>
                      <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                        <span className="numberText">
                          {bookingDetails?.type == "Package"
                            ? "Package ID"
                            : "Trip ID"}
                          <br />
                        </span>
                        <span className="dateText">
                          <span>
                            {bookingDetails?.type == "Package"
                              ? bookingDetails?.tripDetails[0].trip
                                  ?.packageAlphaId
                              : bookingDetails?.tripDetails[0].trip
                                  ?.tripAlphaId}
                          </span>
                        </span>
                      </div>

                      {bookingDetails?.type == "Package" && (
                        <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            Accommodation
                            <br />
                          </span>
                          <span className="dateText">
                            <span>
                              {bookingDetails?.packageWithAccom === "food" ||
                              bookingDetails?.packageWithAccom === "with" ||
                              bookingDetails?.packageWithAccom === "Visa"
                                ? "Included"
                                : "Not Included"}
                            </span>
                          </span>
                        </div>
                      )}

                      {bookingDetails?.type == "Package" && (
                        <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            Food
                            <br />
                          </span>
                          <span className="dateText">
                            <span>
                              {bookingDetails?.packageWithAccom === "food" ||
                              bookingDetails?.packageWithAccom === "Visa"
                                ? "Included"
                                : "Not Included "}
                            </span>
                          </span>
                        </div>
                      )}

                      {bookingDetails?.type == "Package" && (
                        <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            Visa
                            <br />
                          </span>
                          <span className="dateText">
                            <span>
                              {bookingDetails?.packageWithAccom === "Visa"
                                ? "Included"
                                : "Not Included "}
                            </span>
                          </span>
                        </div>
                      )}

                      <div className="flex flex-col">
                        <span className="numberText">
                          {languageSelectedEnglish
                            ? "Travel Itinerary"
                            : language.travelItinerary}{" "}
                          for <br />
                        </span>
                        <span
                        // className="dateText operator1"
                        >
                          {bookingDetails?.passengerDetails?.map(
                            (passenger, index) => (
                              <span key={index}>
                                {passenger.firstName?.charAt(0).toUpperCase() +
                                  passenger.firstName?.slice(1)}{" "}
                                {passenger.lastName?.charAt(0).toUpperCase() +
                                  passenger.lastName?.slice(1)}
                                <br />
                                {passenger.passportNumber}
                                <br />
                              </span>
                            )
                          )}
                        </span>
                        <span className="text-details-invoice">
                          <span className="numberText">
                            Departure Date & Time
                          </span>
                          <span className="dateText departSection">
                            <span>
                              {bookingDetails?.tripDetails[0].trip?.routeFrom}
                            </span>
                            <span>
                              {" "}
                              {bookingDetails?.type == "Package"
                                ? bookingDetails?.tripDetails[0].trip
                                    ?.packageDate
                                : bookingDetails?.tripDetails[0].trip?.tripDate}
                            </span>
                            <span>
                              {
                                bookingDetails?.tripDetails[0].trip
                                  ?.departureTime
                              }
                            </span>
                            {/* <span>{trip1DepartureDate}</span>
                            <span>{trip1DepartureTime}</span> */}
                          </span>
                        </span>
                        <span className="text-details-invoice locatSection">
                          <span className="numberText">
                            Departure Location Link
                            <br />
                          </span>
                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[0]?.trip?.departureLocation}`}
                            className="mapImageOuter "
                            style={{ wordWrap: "break-word" }}
                          >
                            <img
                              src={require("../../assets/mapimage.avif")}
                              className="invoiceImage cursor-pointer"
                              alt=""
                            />
                          </a>

                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[0]?.trip?.departureLocation}`}
                            className="linkText"
                            style={{ wordWrap: "break-word" }}
                          >
                            {
                              bookingDetails.tripDetails[0]?.trip
                                ?.departureLocation
                            }
                          </a>
                        </span>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs="auto" sm={3} className="p-2">
                    <div className="flex flex-col operator">
                      <span className="numberText">Operator</span>
                      <span className="dateText">
                        {bookingDetails?.tripDetails[0].operatorId?.companyname}
                      </span>
                    </div>
                    <div className="flex flex-col operator">
                      <span className="numberText">Bus Type</span>
                      <span className="dateText">
                        {bookingDetails?.tripDetails[0].trip?.busId?.busType}
                      </span>
                    </div>
                    <div className="flex flex-col operator">
                      <span className="numberText">Bus Plate Number</span>
                      <span className="dateText">
                        {bookingDetails?.tripDetails[0]?.trip?.busId?.busNumber}
                      </span>
                    </div>
                    <div className="flex flex-col operator">
                      <span className="numberText">No of Seats</span>
                      <span className="dateText">
                        {/* {bookingDetails[0]?.noOfSeats} */}
                        {bookingDetails?.tripDetails[0]?.noOfSeats}
                      </span>
                    </div>
                    <div className="flex flex-col operator">
                      <span className="numberText">Selected Seat Numbers</span>
                      <span className="dateText">
                        {bookingDetails?.tripDetails[0]?.seats?.join(", ")}
                      </span>
                    </div>
                    <div className="flex flex-col ">
                      <span className="numberText">Arrival Date & Time</span>
                      <span className="dateText">
                        {bookingDetails?.tripDetails[0]?.trip?.routeTo} <br />
                        <span>
                          {" "}
                          {bookingDetails?.type == "Package"
                            ? bookingDetails?.tripDetails[0].trip?.packageDate
                            : bookingDetails?.tripDetails[0].trip
                                ?.tripDate}{" "}
                        </span>
                        <br />
                        {bookingDetails?.tripDetails[0]?.trip?.arrivalTime}
                      </span>
                      <span className="text-details-invoice locatLowerSection">
                        <span className="numberText">
                          {requesInfo?.tripType == "Round Trip" && "1st Trip"}{" "}
                          Departure Location Link
                          <br />
                        </span>
                        <a
                          target="_blank"
                          href={`${bookingDetails?.tripDetails[0]?.trip?.departureLocation}`}
                          className="mapImageOuter "
                          style={{ wordWrap: "break-word" }}
                        >
                          <img
                            src={require("../../assets/mapimage.avif")}
                            className="invoiceImage cursor-pointer"
                            alt=""
                          />
                        </a>

                        <a
                          target="_blank"
                          href={`${bookingDetails?.tripDetails[0]?.trip?.departureLocation}`}
                          className="linkText"
                          style={{ wordWrap: "break-word" }}
                        >
                          {
                            bookingDetails?.tripDetails[0]?.trip
                              ?.departureLocation
                          }
                        </a>
                      </span>
                      <span className="text-details-invoice ">
                        <span className="numberText">
                          <div style={{ display: "flex", gap: "5px" }}>
                            {" "}
                            {requesInfo?.tripType == "Round Trip" && (
                              <span className="locatLowerSection">
                                1st Trip
                              </span>
                            )}
                            Arrival Location Link
                            <br />
                          </div>
                        </span>
                        <a
                          target="_blank"
                          href={`${bookingDetails?.tripDetails[0]?.trip?.arrivalLocation}`}
                          className="mapImageOuter "
                          // style={{ wordWrap: 'break-word' }}
                        >
                          <img
                            src={require("../../assets/mapimage.avif")}
                            className="invoiceImage cursor-pointer"
                            alt=""
                          />
                        </a>
                        <a
                          target="_blank"
                          href={`${bookingDetails?.tripDetails[0]?.trip?.arrivalLocation}`}
                          className="linkText"
                          style={{ wordWrap: "break-word" }}
                        >
                          {
                            bookingDetails?.tripDetails[0]?.trip
                              ?.arrivalLocation
                          }
                        </a>
                      </span>
                      {bookingDetails?.type == "Package" && (
                        <>
                          <span className="numberText">
                            Return Departure Date & Time
                          </span>
                          <span className="dateText">
                            {bookingDetails?.tripDetails[0]?.trip?.routeTo}{" "}
                            <br />
                            <span>
                              {" "}
                              {
                                bookingDetails?.tripDetails[0].trip
                                  ?.packageReturnDate
                              }{" "}
                            </span>
                            <br />
                            {
                              bookingDetails?.tripDetails[0]?.trip
                                ?.returnDepartureTime
                            }
                          </span>
                          <span className="numberText">
                            Return Arrival Date & Time
                          </span>
                          <span className="dateText">
                            {bookingDetails?.tripDetails[0]?.trip?.routeFrom}{" "}
                            <br />
                            <span>
                              {" "}
                              {
                                bookingDetails?.tripDetails[0].trip
                                  ?.packageReturnDate
                              }{" "}
                            </span>
                            <br />
                            {
                              bookingDetails?.tripDetails[0]?.trip
                                ?.returnArrivalTime
                            }
                          </span>
                        </>
                      )}
                    </div>
                  </Grid>
                  {/* <div className="deskTopInvoice"> */}
                  <Grid item xs="auto" sm={3} className="p-2 deskTopInvoice">
                    <div className="border-payment">
                      <div className="flex flex-col">
                        <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Payment Method"
                              : language.paymentMethod}
                            <br />
                          </span>
                          <span className="creditText">
                            {/* {data.paymentMethod} */}

                            {bookingDetails?.paymentMethod}
                          </span>
                        </div>
                        <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {bookingDetails?.type == "Package"
                              ? "Package Fare"
                              : "Trip-1 Fare"}
                            <br />
                          </span>
                          <span className="creditText">
                            SAR {bookingDetails?.tripDetails[0]?.originalPrice}
                          </span>
                        </div>
                        {bookingDetails?.tripDetails[0]?.appliedCoupons?.map(
                          (item) => (
                            <div className="mb-1 md:mb-0 lg:mb-0  flex gap-1 sm:flex-wrap">
                              <span className="numberTextLower">
                                {item?.couponType == "priceDiscount"
                                  ? "Trip-1 Price Discount:"
                                  : "Trip-1 Cash Back:"}
                                <br />
                              </span>
                              <span className="numberTextLower">
                                SAR {item?.amount}
                              </span>
                            </div>
                          )
                        )}
                        {/* <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish ? "Trip-1 Amount Paid" : language.fare}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            SAR {bookingDetails?.tripDetails[0]?.
                              price}
                          </span>
                        </div> */}
                        {bookingDetails?.tripDetails.length === 2 && (
                          <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish
                                ? "Trip-2 Fare"
                                : language.fare}{" "}
                              <br />
                            </span>
                            <span className="creditText">
                              SAR{" "}
                              {bookingDetails?.tripDetails[1]?.originalPrice}
                            </span>
                          </div>
                        )}
                        {bookingDetails?.tripDetails[1]?.appliedCoupons?.map(
                          (item) => (
                            <div className="mb-1 md:mb-0 lg:mb-0  flex gap-1 sm:flex-wrap">
                              <span className="numberTextLower">
                                {item?.couponType == "priceDiscount"
                                  ? "Trip-2 Price Discount:"
                                  : "Trip-2 Cash Back:"}
                                <br />
                              </span>
                              <span className="numberTextLower">
                                SAR {item?.amount}
                              </span>
                            </div>
                          )
                        )}
                        {/* <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish ? "Trip-2 Amount Paid" : language.fare}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            SAR {bookingDetails?.tripDetails[1]?.
                              price}
                          </span>
                        </div> */}
                        {bookingDetails?.type !== "Package" && (
                          <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish
                                ? "Total Fare"
                                : language.fare}{" "}
                              <br />
                            </span>
                            <span className="creditText">
                              SAR {bookingDetails?.totalFare}
                            </span>
                          </div>
                        )}
                        <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Total Price Discount"
                              : language.discount}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            {/* ${Math.round(10.93)}.00 */}
                            SAR{bookingDetails?.totalPriceDiscount}
                          </span>
                        </div>
                        <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Total Cash Back "
                              : language.discount}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            {/* ${Math.round(10.93)}.00 */}
                            SAR{bookingDetails?.totalCashbackDiscount}
                          </span>
                        </div>
                        <div className="flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Total Amount Paid"
                              : language.totalPaidAmount}
                            <br />
                          </span>
                          <span className="creditText">
                            {/* ${Math.round(newPrice)}.00 */}
                            {/* {priceData?.fareAmount} */}
                            SAR
                            {bookingDetails?.totalPaidAmount}
                            {/* {preCouponSubtotal} */}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="invoiceText">
                        {languageSelectedEnglish
                          ? "Transaction ID :"
                          : language.seatNumber}
                        <br />
                        <span className="invoiveNoText">
                          {bookingDetails?.transactionId}
                        </span>
                      </p>
                    </div>
                  </Grid>
                  {/* </div> */}
                </Grid>
              </Grid>
            </Grid>
            {bookingDetails?.tripDetails?.length === 2 && (
              <Grid container className="">
                <Grid item xs={12} display="flex" justifyContent="center">
                  <Grid
                    container
                    xs={12}
                    lg={11}
                    className="invoiceInnerSection"
                  >
                    <Grid
                      item
                      xs="auto"
                      sm={3}
                      className="p-2 flex justify-between gap-[10px]"
                    >
                      <div className="flex flex-col pb-4 border-b border-gray-50">
                        <h1 className="title-travel-status">
                          Trip-2 Travel Itinerary
                        </h1>
                        <p className="statusSection">
                          {languageSelectedEnglish
                            ? "Status:"
                            : language.status}{" "}
                          <span className="pl-2 confirmText">
                            {" "}
                            <Status status={"Confirmed"} />
                            Confirmed
                          </span>
                        </p>
                        <div className="pt-2 qrOuter">
                          <QRCode
                            value={JSON.stringify(QRData)}
                            level="M"
                            size="100%"
                            fgColor="#5D0139"
                          />
                        </div>

                        <div className="lg:text-right text-left">
                          <p className="travel-deadline">
                            {searchedData?.to}
                            {/* {languageSelectedEnglish ? "to" : language.to}{" "} */}
                            {bookingDetails?.tripDetails[1]?.trip?.routeFrom} to{" "}
                            {bookingDetails?.tripDetails[1]?.trip?.routeTo}
                            {searchedData?.from}
                            <br />
                            {/* in {timeDifference1} hours */}
                          </p>
                        </div>
                      </div>
                      <div className="divider "></div>
                    </Grid>

                    <Grid item xs="auto" sm={3} className="p-2">
                      <div className="flex flex-col">
                        <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Travel Itinerary"
                              : language.travelItinerary}{" "}
                            Number <br />
                          </span>
                          <span className="alotNo">
                            {bookingDetails?.travelItineraryNumber}
                          </span>
                        </div>
                        <div className="mb-1 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Itinerary Issue Date"
                              : language.date}
                            <br />
                          </span>
                          <span className="dateText">
                            <span> {issueDate2}</span>
                          </span>
                        </div>
                        <div className="mb-3 md:mb-0 lg:mb-0 flex flex-col">
                          <span className="numberText">
                            Trip ID
                            <br />
                          </span>
                          <span className="dateText">
                            <span>
                              {bookingDetails?.tripDetails[1].trip?.tripAlphaId}
                            </span>
                          </span>
                        </div>

                        <div className="flex flex-col">
                          <span className="numberText">
                            {languageSelectedEnglish
                              ? "Travel Itinerary"
                              : language.travelItinerary}{" "}
                            for <br />
                          </span>
                          {bookingDetails?.passengerDetails?.map(
                            (passenger, index) => (
                              <span key={index}>
                                {passenger.firstName?.charAt(0).toUpperCase() +
                                  passenger.firstName?.slice(1)}{" "}
                                {passenger.lastName?.charAt(0).toUpperCase() +
                                  passenger.lastName?.slice(1)}
                                <br />
                                {passenger.passportNumber}
                                <br />
                              </span>
                            )
                          )}
                          <span className="text-details-invoice">
                            <span className="numberText">
                              Departure Date & Time
                            </span>
                            <span className="dateText departSection">
                              <span>
                                {bookingDetails?.tripDetails[1].trip?.routeFrom}
                              </span>
                              <span>
                                {bookingDetails?.tripDetails[1].trip?.tripDate}
                              </span>
                              <span>
                                {
                                  bookingDetails?.tripDetails[1].trip
                                    ?.departureTime
                                }
                              </span>
                            </span>
                          </span>
                          <span className="text-details-invoice locatSection">
                            <span className="numberText">
                              Departure Location Link
                              <br />
                            </span>
                            <a
                              target="_blank"
                              href={`${bookingDetails?.tripDetails[1].trip?.departureLocation}`}
                              className="mapImageOuter "
                              style={{ wordWrap: "break-word" }}
                            >
                              <img
                                src={require("../../assets/mapimage.avif")}
                                className="invoiceImage cursor-pointer"
                                alt=""
                              />
                            </a>

                            <a
                              target="_blank"
                              href={`${bookingDetails?.tripDetails[1].trip?.departureLocation}`}
                              className="linkText"
                              style={{ wordWrap: "break-word" }}
                            >
                              {
                                bookingDetails?.tripDetails[1].trip
                                  ?.departureLocation
                              }
                            </a>
                          </span>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs="auto" sm={3} className="p-2">
                      <div className="flex flex-col operator">
                        <span className="numberText">Operator</span>
                        <span className="dateText">
                          {
                            bookingDetails?.tripDetails[1]?.operatorId
                              ?.companyname
                          }
                        </span>
                      </div>
                      <div className="flex flex-col operator">
                        <span className="numberText">Bus Type</span>
                        <span className="dateText">
                          {bookingDetails?.tripDetails[1]?.trip?.busId?.busType}
                        </span>
                      </div>
                      <div className="flex flex-col operator">
                        <span className="numberText">Bus Plate Number</span>
                        <span className="dateText">
                          {
                            bookingDetails?.tripDetails[1]?.trip?.busId
                              ?.busNumber
                          }
                        </span>
                      </div>
                      <div className="flex flex-col operator">
                        <span className="numberText">No of Seats</span>
                        <span className="dateText">
                          {bookingDetails?.tripDetails[1]?.noOfSeats}
                        </span>
                      </div>
                      <div className="flex flex-col operator">
                        <span className="numberText">
                          Selected Seat Numbers
                        </span>
                        <span className="dateText">
                          {bookingDetails?.tripDetails[1]?.seats?.join(", ")}
                        </span>
                      </div>
                      <div className="flex flex-col ">
                        <span className="numberText">Arrival Date & Time</span>
                        <span className="dateText">
                          {bookingDetails?.tripDetails[1]?.trip?.routeTo} <br />
                          {bookingDetails?.tripDetails[1]?.trip?.tripDate}{" "}
                          <br />
                          {bookingDetails?.tripDetails[1]?.trip?.arrivalTime}
                        </span>
                        <span className="text-details-invoice locatLowerSection">
                          <span className="numberText">
                            {requesInfo?.tripType == "Round Trip" && "2nd Trip"}{" "}
                            Departure Location Link
                            <br />
                          </span>
                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[1]?.trip?.departureLocation}`}
                            className="mapImageOuter "
                            style={{ wordWrap: "break-word" }}
                          >
                            <img
                              src={require("../../assets/mapimage.avif")}
                              className="invoiceImage cursor-pointer"
                              alt=""
                            />
                          </a>

                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[1]?.trip?.departureLocation}`}
                            className="linkText"
                            style={{ wordWrap: "break-word" }}
                          >
                            {
                              bookingDetails?.tripDetails[1]?.trip
                                ?.departureLocation
                            }
                          </a>
                        </span>
                        <span className="text-details-invoice ">
                          <span className="numberText">
                            <div style={{ display: "flex", gap: "5px" }}>
                              {" "}
                              {requesInfo?.tripType == "Round Trip" && (
                                <span className="locatLowerSection">
                                  2nd Trip
                                </span>
                              )}{" "}
                              Arrival Location Link
                              <br />
                            </div>
                          </span>
                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[1]?.trip?.arrivalLocation}`}
                            className="mapImageOuter "
                            // style={{ wordWrap: 'break-word' }}
                          >
                            <img
                              src={require("../../assets/mapimage.avif")}
                              className="invoiceImage cursor-pointer"
                              alt=""
                            />
                          </a>
                          <a
                            target="_blank"
                            href={`${bookingDetails?.tripDetails[1]?.trip?.arrivalLocation}`}
                            className="linkText"
                            style={{ wordWrap: "break-word" }}
                          >
                            {
                              bookingDetails?.tripDetails[1]?.trip
                                ?.arrivalLocation
                            }
                          </a>
                        </span>
                      </div>
                    </Grid>

                    {/* <Grid item xs="auto" sm={3} className="p-2">
                      <div>
                        <p
                          className="invoiceText"
                        >
                          {languageSelectedEnglish
                            ? "Invoice Number:"
                            : language.seatNumber}
                          <span className="invoiveNoText">
                            {bookingData?.seats.length > 1
                              ? bookingData?.seats.map((seatNo, index) => (
                                <span
                                  key={index}
                                  style={{ fontWeight: 600, color: "#BE892A" }}
                                >
                                  {seatNo}
                                  {index !== bookingData?.seats.length - 1 &&
                                    " & "}
                                </span>
                              ))
                              : bookingData?.seats[0]}
                            27
                          </span>
                        </p>
                      </div>
                      <div className="border-payment">
                        <div className="flex flex-col">
                          <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish
                                ? "Payment Method"
                                : language.paymentMethod}
                              <br />
                            </span>
                            <span className="creditText">

                              {languageSelectedEnglish
                                ? "Credit"
                                : language.credit}
                            </span>
                          </div>
                          <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish ? "Fare" : language.fare}{" "}
                              <br />
                            </span>
                            <span className="creditText">
                              ${Math.round(bookingInfo?.returnTripPrice)}.00
                            </span>
                          </div>
                          <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish
                                ? "Discount"
                                : language.discount}{" "}
                              <br />
                            </span>
                            <span className="creditText">
                              {bookingInfo?.discountPercentage}%
                            </span>
                          </div>
                          <div className="flex flex-col sm:flex-wrap">
                            <span className="numberText">
                              {languageSelectedEnglish
                                ? "Total Amount Paid"
                                : language.totalAmountPaid}
                              <br />
                            </span>
                            <span className="creditText">
                              ${Math.round(newReturnPrice)}.00
                            </span>
                          </div>
                        </div>
                      </div>

                    </Grid> */}
                  </Grid>
                </Grid>
              </Grid>
            )}
            <div className="mobileInvoice">
              <Grid item xs="auto" sm={3} className="p-2">
                <div className="border-payment">
                  <div className="flex flex-col">
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Payment Method"
                          : language.paymentMethod}
                        <br />
                      </span>
                      <span className="creditText">
                        {/* {data.paymentMethod} */}

                        {bookingDetails?.paymentMethod}
                      </span>
                    </div>
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Trip-1 Fare"
                          : language.fare}{" "}
                        <br />
                      </span>
                      <span className="creditText">
                        SAR {bookingDetails?.tripDetails[0]?.originalPrice}
                      </span>
                    </div>
                    {bookingDetails?.tripDetails[0]?.appliedCoupons?.map(
                      (item) => (
                        <div className="mb-1 md:mb-0 lg:mb-0  flex gap-1 sm:flex-wrap">
                          <span className="numberTextLower">
                            {item?.couponType == "priceDiscount"
                              ? "Trip-1 Price Discount:"
                              : "Trip-1 Cash Back:"}
                            <br />
                          </span>
                          <span className="numberTextLower">
                            SAR {item?.amount}
                          </span>
                        </div>
                      )
                    )}
                    {/* <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish ? "Trip-1 Amount Paid" : language.fare}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            SAR {bookingDetails?.tripDetails[0]?.
                              price}
                          </span>
                        </div> */}
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Trip-2 Fare"
                          : language.fare}{" "}
                        <br />
                      </span>
                      <span className="creditText">
                        SAR {bookingDetails?.tripDetails[1]?.originalPrice}
                      </span>
                    </div>
                    {bookingDetails?.tripDetails[1]?.appliedCoupons?.map(
                      (item) => (
                        <div className="mb-1 md:mb-0 lg:mb-0  flex gap-1 sm:flex-wrap">
                          <span className="numberTextLower">
                            {item?.couponType == "priceDiscount"
                              ? "Trip-2 Price Discount:"
                              : "Trip-2 Cash Back:"}
                            <br />
                          </span>
                          <span className="numberTextLower">
                            SAR {item?.amount}
                          </span>
                        </div>
                      )
                    )}
                    {/* <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                          <span className="numberText">
                            {languageSelectedEnglish ? "Trip-2 Amount Paid" : language.fare}{" "}
                            <br />
                          </span>
                          <span className="creditText">
                            SAR {bookingDetails?.tripDetails[1]?.
                              price}
                          </span>
                        </div> */}
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish ? "Total Fare" : language.fare}{" "}
                        <br />
                      </span>
                      <span className="creditText">
                        SAR {bookingDetails?.totalFare}
                      </span>
                    </div>
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Total Price Discount"
                          : language.discount}{" "}
                        <br />
                      </span>
                      <span className="creditText">
                        {/* ${Math.round(10.93)}.00 */}
                        SAR{bookingDetails?.totalPriceDiscount}
                      </span>
                    </div>
                    <div className="mb-3 md:mb-0 lg:mb-0  flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Total Cash Back "
                          : language.discount}{" "}
                        <br />
                      </span>
                      <span className="creditText">
                        {/* ${Math.round(10.93)}.00 */}
                        SAR{bookingDetails?.totalCashbackDiscount}
                      </span>
                    </div>
                    <div className="flex flex-col sm:flex-wrap">
                      <span className="numberText">
                        {languageSelectedEnglish
                          ? "Total Amount Paid"
                          : language.totalPaidAmount}
                        <br />
                      </span>
                      <span className="creditText">
                        {/* ${Math.round(newPrice)}.00 */}
                        {/* {priceData?.fareAmount} */}
                        SAR
                        {bookingDetails?.totalPaidAmount}
                        {/* {preCouponSubtotal} */}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="invoiceText">
                    {languageSelectedEnglish
                      ? "Transaction ID :"
                      : language.seatNumber}
                    <br />
                    <span className="invoiveNoText">
                      {bookingDetails?.transactionId}
                    </span>
                  </p>
                </div>
              </Grid>
            </div>
          </div>
          <div className="bg-white btnPrintOuter mt-[30px]">
            <div className=" mb-4 mt-3 flex gap-[15px] flex-wrap justify-between topButtonInvoice">
              <PDFDownloadLink
                // document={<InvoiceForDownload data={data} />}
                fileName="Invoice"
              >
                <button className="flex items-center downBtn text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-5 py-2 rounded-md text-white bg-green-500 border border-transparent active:bg-green-600 hover:bg-green-600 focus:ring focus:ring-purple-300 w-auto cursor-pointer">
                  Download Travel itinerary{" "}
                  <span className="ml-2 text-base">
                    <IoCloudDownloadOutline />
                  </span>
                </button>
              </PDFDownloadLink>

              <ReactToPrint
                trigger={() => (
                  <button className="flex items-center text-[20px] downBtn text-sm leading-5 transition-colors duration-150 font-medium focus:outline-none px-3 py-2 rounded-md   focus:ring focus:ring-purple-300 w-auto  printInvoiceBtn">
                    {languageSelectedEnglish
                      ? "Print or Save Travel Itinerary"
                      : language.printOrSaveTravelItinerary}{" "}
                    <span className="ml-2">
                      <FiPrinter />
                    </span>
                  </button>
                )}
                content={() => printRef.current}
                documentTitle="Invoice"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InvoiceUser;
